import React from 'react';
import BackgroundImage from 'react-background-image-loader';
import Img from "gatsby-image";
import 'mapbox-gl/dist/mapbox-gl.css';
import Slider from "react-slick";
import { FocusedImage } from "image-focus";
import mapboxgl from 'mapbox-gl';

const BaseHref = "http://46.4.51.11:1337"


const ReferenzDetail = ({ data }) => (

  <div className="refClass">

    <div className="row">
      <div className="col-md-8 col-xs-12">
        <h1>{data.strapiReferenz.Title}</h1>
      </div>

      <div className="col-md-4 col-xs-12 ref_client">
        <p>{data.strapiReferenz.Ref_Kunde}</p>
      </div>
    </div>

    <div className="row" style={{ padding: '0', backgroundColor: 'transparent' }}>
      <div className="col-md-8 col-xs-12" style={{ padding: '0' }}>


        <Slider>

          <div key={"s1" + data.strapiReferenz.id}>
            <FocusImage1 key={"F1" + data.strapiReferenz.id}
              src={data.strapiReferenz.Ref_Img_1.childImageSharp.sizes.src}
              x={data.strapiReferenz.Ref_Img_1_X}
              y={data.strapiReferenz.Ref_Img_1_Y}
            />
          </div>

          <div key={"s2" + data.strapiReferenz.id}>
            <FocusImage2 key={"F2" + data.strapiReferenz.id}
              src={data.strapiReferenz.Ref_Img_2.childImageSharp.sizes.src}
              x={data.strapiReferenz.Ref_Img_2_X}
              y={data.strapiReferenz.Ref_Img_2_Y}
            />
          </div>

          <div key={"s3" + data.strapiReferenz.id}>
            <FocusImage3 key={"F3" + data.strapiReferenz.id}
              src={data.strapiReferenz.Ref_Img_3.childImageSharp.sizes.src}
              x={data.strapiReferenz.Ref_Img_3_X}
              y={data.strapiReferenz.Ref_Img_3_Y}
            />
          </div>

          <div key={"s4" + data.strapiReferenz.id}>
            <FocusImage4 key={"F4" + data.strapiReferenz.id}
              src={data.strapiReferenz.Ref_Img_4.childImageSharp.sizes.src}
              x={data.strapiReferenz.Ref_Img_4_X}
              y={data.strapiReferenz.Ref_Img_4_Y}
            />
          </div>

          <div key={"s5" + data.strapiReferenz.id}>
            <FocusImage5 key={"F5" + data.strapiReferenz.id}
              src={data.strapiReferenz.Ref_Img_5.childImageSharp.sizes.src}
              x={data.strapiReferenz.Ref_Img_5_X}
              y={data.strapiReferenz.Ref_Img_5_Y}
            />
          </div>
   

        </Slider>

      </div>
      <div className="col-md-4 col-xs-12" style={{ backgroundColor: '#fff' }}>
        <div className="row">
          <div className="col ref_summary" id="info_summary">
            <p>{data.strapiReferenz.Ref_Description_Intro}</p>
          </div>
        </div>
        <div className="row">
          <div className="col ref_description">
            <h2>Projektbeschreibung</h2>
            <div dangerouslySetInnerHTML={{ __html: data.strapiReferenz.Ref_Description_Fulltext }} />

          </div>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-md-8 col-xs-12">
        <div className="row ref_info" id="info_line">
          <div className="col-xs-12 col-md-6 col-sm-6">
            <h3>Fakten</h3>
            <div dangerouslySetInnerHTML={{ __html: data.strapiReferenz.Ref_Fakten }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6">
            <h3>Unsere Leistungen</h3>
            <div dangerouslySetInnerHTML={{ __html: data.strapiReferenz.Ref_Leistungen }} />
          </div>
        </div>
      </div>

      <div className="col-md-4 col-xs-12" id="mContainer" style={{ padding: '0' }}>

        <RefMap zoom={data.strapiReferenz.zoom} center={[data.strapiReferenz.lon, data.strapiReferenz.lat]} />

      </div>

    </div>

  </div>
);

class FocusImage1 extends React.Component {

  componentDidMount() {
    this.focusMyImage1()
    window.addEventListener("resize", this.focusMyImage1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.focusMyImage1);
  }

  focusMyImage1 = () => {
    const img1 = document.querySelector('.focused-image1');
    let x
    let y
    setTimeout(() => {
      const focusedImage1 = new FocusedImage(img1, {
        focus: {
          x: this.props.x,
          y: this.props.y
        }
      });
    }, 500);
    img1.classList.add('fade-in')
  }

  render() {
    return (
      <div className="focused-image-container">
        <img className="focused-image1" src={this.props.src} />
      </div> 
    )
  }

}


class FocusImage2 extends React.Component {

  componentDidMount() {
    this.focusMyImage2()
    window.addEventListener("resize", this.focusMyImage2);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.focusMyImage2);
  }

  focusMyImage2 = () => {
    const img2 = document.querySelector('.focused-image2');
    let x
    let y
    setTimeout(() => {
      const focusedImage2 = new FocusedImage(img2, {
        focus: {
          x: this.props.x,
          y: this.props.y
        }
      });
    }, 500);
    img2.classList.add('fade-in')
  }

  render() {
    return (
      <div className="focused-image-container">
        <img className="focused-image2" src={this.props.src} />
      </div>
    )
  }
}


class FocusImage3 extends React.Component {

  componentDidMount() {
    this.focusMyImage3()
    window.addEventListener("resize", this.focusMyImage3);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.focusMyImage3);
  }

  focusMyImage3 = () => {
    const img3 = document.querySelector('.focused-image3');
    let x
    let y
    setTimeout(() => {
      const focusedImage3 = new FocusedImage(img3, {
        focus: {
          x: this.props.x,
          y: this.props.y
        }
      });
    }, 500);
    img3.classList.add('fade-in')
  }

  render() {
    return (
      <div className="focused-image-container">
        <img className="focused-image3" src={this.props.src} />
      </div>
    )
  }
}


class FocusImage4 extends React.Component {

  componentDidMount() {
    this.focusMyImage4()
    window.addEventListener("resize", this.focusMyImage4);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.focusMyImage4);
  }

  focusMyImage4 = () => {
    const img4 = document.querySelector('.focused-image4');
    let x
    let y
    setTimeout(() => {
      const focusedImage4 = new FocusedImage(img4, {
        focus: {
          x: this.props.x,
          y: this.props.y
        }
      });
    }, 500);
    img4.classList.add('fade-in')
  }

  render() {
    return (
      <div className="focused-image-container">
        <img className="focused-image4" src={this.props.src} />
      </div>
    )
  }
}



class FocusImage5 extends React.Component {


  componentDidMount() {
    this.focusMyImage5();
    window.addEventListener("resize", this.focusMyImage5);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.focusMyImage5);
  }

  focusMyImage5 = () => {
    const img5 = document.querySelector('.focused-image5');
    let x
    let y
    setTimeout(() => {
      const focusedImage5 = new FocusedImage(img5, {
        focus: {
          x: this.props.x,
          y: this.props.y
        }
      });
    }, 100);
    img5.classList.add('fade-in')
  }

  render() {
    return (
      <div className="focused-image-container">
        <img className="focused-image5" src={this.props.src} />
      </div>
    )
  }
}




class RefMap extends React.Component {

  createMap() {
    const iconSize = 1
    const map = new mapboxgl.Map({
      center: this.props.center,
      container: 'map',
      style: 'mapbox://styles/mapbox/light-v9',
      trackResize: 'true',
      zoom: this.props.zoom,
      pitch: 50,
      detectRetina: 'true'
    })
    // map.scrollZoom.disable()


    var el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIwMCIgaGVpZ2h0PSIxMjAwIiB2aWV3Qm94PSIwIDAgMTIwMCAxMjAwIj48Zz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmZmZmZmIj48L3JlY3Q+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjAwIDYwMCkgc2NhbGUoMC42OSAwLjY5KSByb3RhdGUoMCkgdHJhbnNsYXRlKC02MDAgLTYwMCkiIHN0eWxlPSJmaWxsOiNmNDdmMjQ7Ij48c3ZnIGZpbGw9IiNmNDdmMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAgMTAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNTAsMjVjNi44OTYsMCwxMi41LDUuNjA0LDEyLjUsMTIuNVM1Ni44OTYsNTAsNTAsNTBzLTEyLjUtNS42MDQtMTIuNS0xMi41UzQzLjEwNCwyNSw1MCwyNXogTTUwLDAgIEMyOS4xNjcsMCwxMi41LDE2LjY2NywxMi41LDM3LjVTMjkuMTY3LDc1LDUwLDEwMGMyMC44MzMtMjUsMzcuNS00MS42NjcsMzcuNS02Mi41UzcwLjgzMywwLDUwLDB6Ij48L3BhdGg+PC9zdmc+PC9nPjwvZz48L3N2Zz4=);)'
    // var marker = new mapboxgl.Marker()

    map.on('load', () => {

      new mapboxgl.Marker(el)
        .setLngLat(this.props.center)
        .addTo(map);

      (map) => { map.resize() }

    })
  }

  componentDidMount() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYnVyZWF1d2Vocm1hbm4iLCJhIjoiY2psMnMycDZ4MXRwZTNrbGJqOW5vMWZsbSJ9.Rxv80w8JfySMDLK3dUrsqg'
    this.createMap()
  }

  render() {
    return (

      <div id={'map'} style={{ width: '100%', height: '100%' }} />

    )
  }
}


export default ReferenzDetail;


export const query = graphql`
  query ReferenzDetail($id: String!) {
    strapiReferenz(id: { eq: $id }) {
      id
      Title
      Ref_Description_Intro
      Ref_Description_Fulltext
      Ref_Leistungen
      Ref_Kunde
      Ref_Fakten
      Ref_Category
      lat
      lon
      zoom
      Ref_Images {
        url           
      }
      Ref_Img_1 {
        childImageSharp{
            sizes(quality: 80) {
            src
          }
        }
      }
      Ref_Img_1_X
      Ref_Img_1_Y
      Ref_Img_2 {
        childImageSharp{
          sizes(quality: 80) {
            src
          }
        }
      }
      Ref_Img_2_X
      Ref_Img_2_Y
      Ref_Img_3 {
        childImageSharp{
           sizes(quality: 80) {
            src
          }
        }
      }
      Ref_Img_3_X
      Ref_Img_3_Y
      Ref_Img_4 {
       childImageSharp{
         sizes(quality: 80) {
            src
           }
         }
      }
      Ref_Img_4_X
      Ref_Img_4_Y
      Ref_Img_5 {
        childImageSharp{
          sizes(quality: 80) {
              src
            }
          }
        }
      Ref_Img_5_X
      Ref_Img_5_Y
    },
     strapiMetadata{
        SiteTitle
        Keywords
        placeholder_img{
          childImageSharp{
            sizes{
              src
            }
          }
        }
      }
  }
`


// WEBPACK FOOTER //
// ./src/templates/referenz_detail.js